export default __webpack_public_path__ + "1aec8f4f991b9c9e1474b2d45c84a796.png";